import { FC } from 'react'

import languageService from '../../../../../../../services/LanguageService'
import { useCurrentUserLanguage } from '../../../../../../account/hooks/useCurrentUserLanguage'
import type { EventComment } from '../../../../../../live-events/types/TrackingEvents'
import { UnifiedNewsEntry } from '../../../../../types/UnifiedNewsEntry'
import { LiveEventSubHeader } from '../LiveEventSubHeader'

type LiveEventAnalystNoteSubHeaderProps = {
  newsEntry: UnifiedNewsEntry
  showLimitedContent?: boolean
}

export const LiveEventAnalystNoteSubHeader: FC<LiveEventAnalystNoteSubHeaderProps> = ({ newsEntry, showLimitedContent }) => {
  const currentUserLanguage = useCurrentUserLanguage()

  const noteTitle =
    (newsEntry.feedEntry.entryData.comment as EventComment)?.content?.title?.[currentUserLanguage] ||
    (newsEntry.feedEntry.entryData.comment as EventComment)?.content?.title?.[languageService.defaultLanguage]
  const { start = 0, end = 0 } = newsEntry.feedEntry.entryData
  const interval = { start, end }

  return <LiveEventSubHeader linkLabel={noteTitle} interval={interval} showLimitedContent={showLimitedContent} />
}
